<template>
    <v-container fluid>
        <v-card class="mb-5 pa-2">
            <card-header
                :title="
                    $t('planPackageModules.form.texts.title', {
                        'title-prefix': $t('form.edit-prefix'),
                    })
                "
            />

            <v-row class="pl-6" v-if="planPackage">
                <v-col>
                    <package-details :plan-package="planPackage" />
                </v-col>
            </v-row>

            <template v-if="!model">
                <v-container fluid class="fill-height">
                    <v-row justify="center" align="center">
                        <v-col class="text-center" xs="12" md="12">
                            <v-progress-circular
                                :size="50"
                                color="primary"
                                indeterminate
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <template v-else>
                <v-form ref="form" @submit.prevent="save">
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <div class="mt-7">
                                    <strong
                                        >{{
                                            $t(
                                                'planPackageModules.form.labels.module',
                                            )
                                        }}:</strong
                                    >
                                    {{
                                        model.module && model.module.name
                                            ? model.module.name
                                            : '-'
                                    }}
                                </div>
                            </v-col>
                        </v-row>

                        <form-component
                            :module="model"
                            :dependency-selection.sync="dependencySelection"
                            :courtesy-selection.sync="courtesySelection"
                            :combo-selection.sync="comboSelection"
                        />
                    </v-card-text>

                    <form-actions :loadingSave="loading" />
                </v-form>
            </template>
        </v-card>
    </v-container>
</template>

<script>
import CardHeader from '@/components/utils/CardHeader'
import FormActions from '@/components/utils/FormActions'
import PlanPackage from '@/models/plans/PlanPackage'
import PlanPackageModule from '@/models/plans/PlanPackageModule'
import FormComponent from './Form.vue'
import PackageDetails from '@/views/planPackages/PackageDetails'

export default {
    props: ['id', 'module'],

    components: {
        CardHeader,
        FormActions,
        FormComponent,
        PackageDetails,
    },

    data: () => ({
        model: null,
        loading: false,
        dependencySelection: [],
        courtesySelection: [],
        comboSelection: [],
        planPackage: null,
    }),

    created() {
        this.init()
    },

    methods: {
        async init() {
            const planPackage = new PlanPackage()
            this.planPackage = await planPackage.find(this.id)

            const model = new PlanPackageModule(this.id)
            const response = await model.find(this.module)
            this.model = response
            // seed extras selections from model, if present
            if (this.model && this.model.dependency) {
                this.dependencySelection = this.model.dependency.map(i => ({
                    external_id: i.id,
                }))
            }
            if (this.model && this.model.courtesy) {
                this.courtesySelection = this.model.courtesy.map(i => ({
                    external_id: i.id,
                }))
            }
            if (this.model && this.model.combo) {
                this.comboSelection = this.model.combo.map(i => ({
                    external_id: i.id,
                }))
            }
        },
        async save() {
            this.loading = true
            // map extras back to model payload
            this.model.dependency = (this.dependencySelection || []).map(m => ({
                id: m.external_id,
                module_id: m.external_id,
            }))
            this.model.courtesy = (this.courtesySelection || []).map(m => ({
                id: m.external_id,
                name: m.name,
                price: m.partner_price,
                module_id: m.external_id,
                price_type: m.price_type,
                external_id: null,
            }))
            this.model.combo = (this.comboSelection || []).map(m => ({
                id: m.external_id,
                name: m.name,
                price: m.partner_price,
                module_id: m.external_id,
                price_type: m.price_type,
                external_id: null,
            }))
            const clone = this.model.clone()

            let res = null
            try {
                res = await clone.save().catch(() => {})
            } finally {
                this.loading = false
            }
            if (!res) return
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('planPackageModules.form.feedback.success'),
            )
            this.$router.push({
                name: 'planPackageModules.index',
                params: { id: this.id },
            })
        },
    },
}
</script>
